export const formatMobile = (mobile: string) => {
  // 숫자만 추출 (혹시 하이픈이나 공백이 들어온 경우 대비)
  const digits = mobile.replace(/\D/g, "");

  // 휴대폰 번호 (010, 011, 016, 017, 018, 019)
  if (/^01[016789]\d{7,8}$/.test(digits)) {
    return digits.replace(/(\d{3})(\d{3,4})(\d{4})/, "$1-$2-$3");
  }
  // 서울 번호 (02)
  if (/^02\d{7,8}$/.test(digits)) {
    return digits.replace(/(\d{2})(\d{3,4})(\d{4})/, "$1-$2-$3");
  }
  // 지역 번호 (031, 032, 051, 064 등)
  if (/^0\d{1,2}\d{7,8}$/.test(digits)) {
    return digits.replace(/(\d{3})(\d{3,4})(\d{4})/, "$1-$2-$3");
  }
  // 대표번호 (15xx, 16xx, 18xx)
  if (/^1[568]\d{2}\d{4}$/.test(digits)) {
    return digits.replace(/(\d{4})(\d{4})/, "$1-$2");
  }
  // 인터넷 전화 (070)
  if (/^070\d{8}$/.test(digits)) {
    return digits.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
  }
  // 안심번호 (050x)
  if (/^050\d{8}$/.test(digits)) {
    return digits.replace(/(\d{4})(\d{4})(\d{4})/, "$1-$2-$3");
  }

  // 기본적으로 그대로 반환
  return mobile;
};